import { Sku } from '../item/sku'

export class OrderItem extends Sku {

  order_id: number
  date: string
  customer: string
  channel: string
  comment: string
  item_id: number
  cost: number
  rebate: number
  return_shipping_fee: number
  count: number
  price: number
  shipping_fee: number

  constructor(data: any = {}) {
    super(data)
    this.order_id = data.order_id
    this.date = data.date
    this.customer = data.customer
    this.channel = data.channel
    this.comment = data.comment
    this.item_id = data.item_id
    this.cost = data.cost || 0
    this.count = data.count || 0
    this.rebate = data.rebate || 0
    this.return_shipping_fee = data.return_shipping_fee || 0
    this.price = data.price || 0
    this.shipping_fee = data.shipping_fee || 0
  }

  get profit(): number {
    return this.price - this.cost * this.count - this.return_shipping_fee - this.shipping_fee - this.rebate
  }

  get editLink(): string {
    return `/finance/sales/order/${this.order_id}`
  }

  get itemLink(): string {
    return `/inventory/items/${this.item_id}`
  }

  get returnLink(): any[] {
    return [`/finance/sales/return`, { item_id: this.item_id, order_id: this.order_id }]
  }

  get countArray(): number[] {
    return Array.apply(null, {length: this.count + 1}).map(Number.call, Number).slice(1)
  }

  get sku_link(): string {
    return this.link
  }

}



// WEBPACK FOOTER //
// ./src/app/models/finance/order-item.ts